'use strict';
import React from 'react';
import classnames from 'classnames';
import googleMapLoader from 'utils/google_map_loader';
import listensToClickOutside from 'react-onclickoutside/decorator';
import FormField from 'forms/formField';
import keycode from 'keycode';

class PlzCityInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            focussed: false
        };
    }


    static propTypes = {
        field: React.PropTypes.object.isRequired
    };


    static defaultProps = {
        suggestType: 'postcode'
    };


    componentDidMount() {
        googleMapLoader().then(::this.loadPlaces);
    }


    loadPlaces() {
        if (window.google.maps.places && !this.autocompleteService) {
            this.autocompleteService = new google.maps.places.AutocompleteService();
            this.setState({
                googleApiLoaded: true
            });
        }
    }


    onBlur(e) {

        this.setState({focussed: false});
        if (this.props.field.onBlur) {
            this.props.field.onBlur(e);
        }
    }


    onFocus(e) {

        this.setState({focussed: true});
        if (this.props.field.onFocus) {
            this.props.field.onFocus(e);
        }
    }


    onChange(e) {

        this.autoSuggest(e.target.value, this.props.suggestType);
        this.props.field.onChange(e);
    }


    handleClickOutSide() {

        this.setState({focussed: false});
    }


    onKeyDown(e) {

        if (e.keyCode === keycode('tab')) {
            this.setState({focussed: false});
            if (this.props.field.onBlur) {
                this.props.field.onBlur(e);
            }
        }
    }

    selectSuggestion = (suggestion, e) => {

        e.preventDefault();
        this.props.field.onChange(suggestion);
        this.setState({focussed: false, predictions: [] }, () => {
            this.refs.input.focus(); // Focus the field again to be able to use tab to jump to the next field
        });
    };


    autoSuggest(value, type) {

        if (this.state.googleApiLoaded && value) {

            this.autocompleteService.getPlacePredictions({

                input: value,
                componentRestrictions: {country: 'de'},
                types: [(type === 'postcode') ? '(regions)' : '(cities)']

            }, (predictions, status) => {
                if (status === 'OK') {

                    // While searching for postcode we use the regions object.. this
                    // MUST NOT contain actually a postcode so we filter out all results
                    // which are not a postcode
                    if (type === 'postcode') {
                        predictions = predictions.reduce((prev, curr) => {
                            if (curr.types[0] === 'postal_code') {
                                return prev.concat(curr);
                            }
                            return prev;
                        }, []);
                    }

                    // Generate an an array of objects
                    predictions = (type === 'postcode')
                        ?
                        // Postcode
                        predictions.map(prediction => {
                            return {
                                postcode: prediction.terms[0].value,
                                city: prediction.terms[1].value
                            };
                        })
                        :
                        // Cities
                        predictions.map(prediction => {
                            return {
                                city: prediction.terms[0].value
                            };
                        });

                    this.setState({
                        predictions: predictions
                    });
                }
            });
        }
    }


    renderSuggestions() {

        if (!this.state.focussed) {
            return false;
        }
        console.log('this.state.predictions', this.state.predictions);
        if ((this.state.predictions || []).length > 0) {
            return (
                <ul className={classnames(
                    'item__suggestions',
                    {
                        'item__suggestions--error': this.props.field.error && this.props.field.touched
                    },
                    {
                        'item__suggestions--focus': this.state.focussed
                    }
                )}>
                    {this.state.predictions.map((prediction, key) => {
                        let value = prediction[(this.props.suggestType === 'postcode') ? 'postcode' : 'city'];
                        return (
                            <li key={key}>
                                <a href="#" onClick={this.selectSuggestion.bind(null, prediction)}>{value}</a>
                            </li>
                        );
                    })}
                </ul>
            );
        }
    }


    render() {

        var {field, help, label, onChange, showErrorMessage, ...inputProps} = this.props;
        var error = field.touched && field.error;

        return (
            <FormField field={field} help={help} inputProps={inputProps}>
                <div className={classnames(
                    'item__input',
                    'item__input--text',
                    {'item__input--error': error},
                    {'item__input--focus': this.state.focussed}
                )}>
                    <label htmlFor={field.name}>{field.placeholder}:</label>
                    <input
                        {...inputProps}
                        ref="input"
                        className="input__plz_city"
                        name={field.name}
                        onFocus={::this.onFocus}
                        onChange={::this.onChange}
                        onKeyDown={::this.onKeyDown}
                        maxLength={this.props.suggestType === 'postcode' ? 5 : 255}
                        type="text"
                        value={field.value}
                    />
                    { error && <div className="input__error">{error}</div>}
                </div>
                {this.renderSuggestions()}
            </FormField>
        )
    }
}

export default listensToClickOutside(PlzCityInput);



// WEBPACK FOOTER //
// ./static/app/forms/plzCityInput.jsx